import PaginationCommon from './containers/paginationCommon'

export {default as PaginationCommonLayout} from './components/paginationCommonLayout'

export default PaginationCommon
